import * as React from "react";
import Header from "./Header";
import FiledCancelledView from "../filed/FiledCancelledView";

export default function LayoutCancelledFiled() {
  return (
    <>
      <Header />
      <FiledCancelledView />
    </>
  );
}
